import React, { useState, useRef, useEffect } from "react";
import { FiLock, FiLogOut, FiUser } from "react-icons/fi";
import { FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useAuth } from "../context/AuthContext"; // adjust path if needed

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { logout } = useAuth();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    setOpen(false);

    Swal.fire({
      title: "Logout?",
      text: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#2563eb",
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("🚪 User confirmed logout");
        logout(); // clears auth + redirects
      }
    });
  };

  return (
    <header className="h-20 flex items-center justify-between px-8 bg-white border-b border-slate-200 sticky top-0 z-20">
      {/* LEFT */}
      <div>
        <h1 className="text-xl font-bold text-blue-700">
          ADANA
          <span className="text-slate-500 font-medium ml-2">
            – colour your life
          </span>
        </h1>
      </div>

      {/* RIGHT */}
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setOpen(!open)}
          className="h-10 w-10 rounded-xl bg-slate-100 hover:bg-slate-200 flex items-center justify-center"
        >
          <FiUser className="text-slate-600 text-lg" />
        </button>

        {/* DROPDOWN */}
        {open && (
          <div className="absolute right-0 mt-2 w-48 bg-white border border-slate-200 rounded-xl shadow-lg overflow-hidden">
            <button
              onClick={() => {
                setOpen(false);
                navigate("/profile");
              }}
              className="flex items-center gap-3 px-4 py-3 text-sm text-slate-700 hover:bg-slate-100 w-full"
            >
              <FaUserCircle />
              Profile
            </button>

            <button
              className="flex items-center gap-3 px-4 py-3 text-sm text-slate-700 hover:bg-slate-100 w-full"
               onClick={() => {
                setOpen(false);
                navigate("/change-password");
              }}
            >
              <FiLock />
              Change Password
            </button>

            <button
              onClick={handleLogout}
              className="flex items-center gap-3 px-4 py-3 text-sm text-red-600 hover:bg-red-50 w-full"
            >
              <FiLogOut />
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
